exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2_hh0BAJlStVruBXCQ-bbR{display:-webkit-box;display:-ms-flexbox;display:flex}._1yIvDvFzw70UllXVyCYOr6,._2_hh0BAJlStVruBXCQ-bbR{-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0;overflow:hidden}html[dir] ._2JB1Nhl-IAz49eWIEZaVcu{margin-top:3px}html[dir=ltr] ._2JB1Nhl-IAz49eWIEZaVcu{margin-right:6px!important}html[dir=rtl] ._2JB1Nhl-IAz49eWIEZaVcu{margin-left:6px!important}", ""]);

// exports
exports.locals = {
	"wrapper": "_2_hh0BAJlStVruBXCQ-bbR",
	"fileshub": "_1yIvDvFzw70UllXVyCYOr6",
	"favoriteButtonInHeader": "_2JB1Nhl-IAz49eWIEZaVcu"
};